(function () {
  'use strict';

  // ---------- Hero-Slider ----------
  function initHero(root) {
    if (root.dataset.pfHeroInit) return;
    root.dataset.pfHeroInit = '1';

    var slides = [].slice.call(root.querySelectorAll('[data-pf-hero-slide]'));
    var dots = [].slice.call(root.querySelectorAll('[data-pf-hero-dot]'));
    var caps = [].slice.call(root.querySelectorAll('[data-pf-hero-cap]'));
    if (slides.length < 1) return;

    var index = 0;
    var timer = null;
    var delay = parseInt(root.getAttribute('data-pf-hero-autoplay'), 10) || 0;

    function show(i) {
      index = (i + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === index); });
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === index); });
      caps.forEach(function (c, k) { c.hidden = k !== index; });
    }
    function next() { show(index + 1); }
    function prev() { show(index - 1); }

    function start() { if (delay > 0 && slides.length > 1) { stop(); timer = setInterval(next, delay * 1000); } }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    root.querySelectorAll('[data-pf-hero-next]').forEach(function (b) { b.addEventListener('click', function () { next(); start(); }); });
    root.querySelectorAll('[data-pf-hero-prev]').forEach(function (b) { b.addEventListener('click', function () { prev(); start(); }); });
    dots.forEach(function (d, k) { d.addEventListener('click', function () { show(k); start(); }); });

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    // Respektiert die Systemeinstellung "Bewegung reduzieren".
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) delay = 0;

    show(0);
    start();
  }

  // ---------- horizontale Karussells (Top-Seller, Videos) ----------
  function initTrack(wrap) {
    if (wrap.dataset.pfTrackInit) return;
    wrap.dataset.pfTrackInit = '1';
    var track = wrap.querySelector('[data-pf-hm-track]');
    if (!track) return;

    function step(dir) { track.scrollBy({ left: dir * track.clientWidth * 0.85, behavior: 'smooth' }); }
    wrap.querySelectorAll('[data-pf-hm-prev]').forEach(function (b) { b.addEventListener('click', function () { step(-1); }); });
    wrap.querySelectorAll('[data-pf-hm-next]').forEach(function (b) { b.addEventListener('click', function () { step(1); }); });

    function sync() {
      var scrollable = track.scrollWidth > track.clientWidth + 2;
      wrap.querySelectorAll('[data-pf-hm-prev],[data-pf-hm-next]').forEach(function (b) { b.hidden = !scrollable; });
    }
    sync();
    window.addEventListener('resize', sync);
  }

  // ---------- FAQ ----------
  function initFaq(list) {
    if (list.dataset.pfFaqInit) return;
    list.dataset.pfFaqInit = '1';
    list.addEventListener('click', function (e) {
      var q = e.target.closest('[data-pf-faq-q]');
      if (!q) return;
      var item = q.closest('[data-pf-faq-item]');
      if (!item) return;
      var open = !item.classList.contains('is-open');
      if (list.getAttribute('data-pf-faq-single') === '1') {
        list.querySelectorAll('[data-pf-faq-item]').forEach(function (other) {
          if (other !== item) {
            other.classList.remove('is-open');
            var s = other.querySelector('[data-pf-faq-sign]');
            var b = other.querySelector('[data-pf-faq-q]');
            if (s) s.textContent = '+';
            if (b) b.setAttribute('aria-expanded', 'false');
          }
        });
      }
      item.classList.toggle('is-open', open);
      var sign = item.querySelector('[data-pf-faq-sign]');
      if (sign) sign.textContent = open ? '–' : '+';
      q.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  // ---------- Video: Poster gegen echtes Video / Einbettung tauschen ----------
  function initVideo(root) {
    if (root.dataset.pfVidInit) return;
    root.dataset.pfVidInit = '1';
    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-pf-vid-play]');
      if (!btn) return;
      var stage = btn.closest('[data-pf-vid-stage]');
      if (!stage) return;
      var embed = stage.getAttribute('data-embed');
      var file = stage.getAttribute('data-file');
      if (file) {
        stage.innerHTML = '<video src="' + file + '" controls autoplay playsinline></video>';
      } else if (embed) {
        stage.innerHTML = '<iframe src="' + embed + '" title="Video" allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen frameborder="0" style="width:100%;height:100%;display:block"></iframe>';
      }
    });
  }

  function boot() {
    document.querySelectorAll('[data-pf-hero]').forEach(initHero);
    document.querySelectorAll('[data-pf-hm-trackwrap]').forEach(initTrack);
    document.querySelectorAll('[data-pf-faq-list]').forEach(initFaq);
    document.querySelectorAll('[data-pf-vid-root]').forEach(initVideo);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();